import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { skillsClient } from '#pplx_generated/typespec/rest/skills/client.js';
export async function listSelectableSkills(params, reason) {
    const { data, error, response } = await skillsClient.GET('/rest/skills/selectable', reason, {
        params: {
            query: params,
        },
    });
    if (error || !data) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to fetch selectable skills',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
}
//# sourceMappingURL=listSelectableSkills.js.map